import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// looks like we have Buffer support on client, though I don't know where it's coming from
// this is here to ensure if that is removed this never breaks in client.
const decode = typeof atob === 'function' ? atob : str => Buffer.from(str, 'base64').toString();
function decode64(encoded = '') {
    try {
        return decode(encoded);
    } catch (e) {
        return '';
    }
}

const AbsoluteAnchorComponent = props => {
    // dispatch prop is not used, but it's extracted here,
    // so that otherProps could be safely spread on the <a> elememt
    const {
        children,
        href,
        linkReference,
        linkable,
        localeDomain,
        dataTn,
        dispatch, // eslint-disable-line no-unused-vars
        ...otherProps
    } = props;
    // href may be passed in as an over-ride for the encoded linkReference. Used for 'all' link(s)
    const useHref = href ? href : decode64(linkReference);
    // If href is undefined or null, React will simply render an empty anchor element,
    // and if localeDomain is not set, it should render href as it is
    const absoluteUrl = localeDomain && useHref ? `https://${localeDomain}${useHref}` : useHref;

    if (linkable === true) {
        return (
            <a href={absoluteUrl} data-tn={dataTn} {...otherProps}>
                {children}
            </a>
        );
    } else {
        return (
            <span data-tn={dataTn} {...otherProps}>
                {children}
            </span>
        );
    }
};

AbsoluteAnchorComponent.propTypes = {
    localeDomain: PropTypes.string.isRequired,
    children: PropTypes.node,
    dataTn: PropTypes.string,
    href: PropTypes.string,
    linkReference: PropTypes.string,
    linkable: PropTypes.bool,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => {
    const { intlVariables } = state;

    return { localeDomain: intlVariables.localeDomain };
};

export const AbsoluteAnchor = connect(mapStateToProps)(AbsoluteAnchorComponent);
